<footer class="custom-footer">
  <div class="container">
    <div class="footer-grid">

      <!-- 品牌 + 訂閱 -->
      <div class="footer-brand">
        <div class="d-flex align-items-center mb-3">
          <img src="assets/imalogo.png" alt="IMA One" width="32" height="32" class="me-2">
          <span class="footer-brand__name">IMA One</span>
        </div>
        <p class="footer-brand__desc">
          {{ 'marketing.footer.brandDesc' | translate }}
        </p>

        <div class="footer-news">
          <label class="footer-col__title" for="footer-news-email">{{ 'marketing.footer.newsletterTitle' | translate }}</label>
          <p class="footer-news__hint">{{ 'marketing.footer.newsletterHint' | translate }}</p>

          <form class="footer-news__form" (ngSubmit)="subscribe()" *ngIf="!subscribed()">
            <input
              id="footer-news-email"
              type="email"
              name="newsEmail"
              [(ngModel)]="email"
              [placeholder]="'marketing.footer.emailPlaceholder' | translate"
              autocomplete="email"
              [disabled]="submitting()"
            />
            <button type="submit" class="footer-news__btn" [disabled]="submitting()">
              {{ submitting() ? ('marketing.footer.submitting' | translate) : ('marketing.footer.subscribe' | translate) }}
            </button>
          </form>

          <p class="footer-news__ok" *ngIf="subscribed()">
            <svg [cIcon]="icons.cilCheckCircle"></svg> {{ 'marketing.footer.subscribeSuccess' | translate }}
          </p>
          <p class="footer-news__err" *ngIf="errorMsg()">{{ errorMsg() }}</p>
          <p class="footer-news__legal" *ngIf="!subscribed()">
            {{ 'marketing.footer.newsletterLegalPrefix' | translate }}<a routerLink="/legal/privacy">{{ 'marketing.footer.privacyPolicy' | translate }}</a>{{ 'marketing.footer.newsletterLegalSuffix' | translate }}
          </p>
        </div>

        <div class="social-links">
          <a href="https://page.line.me/ict8881e" target="_blank" rel="noopener" aria-label="LINE">
            <svg [cIcon]="icons.cilChatBubble" size="lg"></svg>
          </a>
          <a href="mailto:ima@ima-ems.com" aria-label="Email">
            <svg [cIcon]="icons.cilEnvelopeClosed" size="lg"></svg>
          </a>
        </div>
      </div>

      <!-- 產品與服務 -->
      <div class="footer-col">
        <h6 class="footer-col__title">{{ 'marketing.footer.colProducts' | translate }}</h6>
        <ul class="list-unstyled footer-col__list">
          <li><a routerLink="/discover/features" class="footer-link">{{ 'marketing.nav.features' | translate }}</a></li>
          <li><a routerLink="/discover/solutions" class="footer-link">{{ 'marketing.nav.solutions' | translate }}</a></li>
          <li><a routerLink="/service/analysis" class="footer-link">{{ 'marketing.nav.serviceAnalysis' | translate }}</a></li>
          <li><a routerLink="/service/audit" class="footer-link">{{ 'marketing.nav.serviceAudit' | translate }}</a></li>
          <li><a routerLink="/service/maintenance" class="footer-link">{{ 'marketing.nav.serviceMaintenance' | translate }}</a></li>
          <li><a routerLink="/service/consulting" class="footer-link">{{ 'marketing.nav.serviceConsulting' | translate }}</a></li>
        </ul>
      </div>

      <!-- 資源 -->
      <div class="footer-col">
        <h6 class="footer-col__title">{{ 'marketing.footer.colResources' | translate }}</h6>
        <ul class="list-unstyled footer-col__list">
          <li><a routerLink="/pricing" class="footer-link">{{ 'marketing.nav.pricing' | translate }}</a></li>
          <li><a routerLink="/discover/cases" class="footer-link">{{ 'marketing.nav.cases' | translate }}</a></li>
          <li><a routerLink="/help" class="footer-link">{{ 'marketing.footer.userGuide' | translate }}</a></li>
          <li><a routerLink="/about" class="footer-link">{{ 'marketing.nav.about' | translate }}</a></li>
        </ul>
      </div>

      <!-- 聯絡 -->
      <div class="footer-col">
        <h6 class="footer-col__title">{{ 'marketing.footer.colContact' | translate }}</h6>
        <ul class="list-unstyled footer-col__list footer-col__contact">
          <li><a routerLink="/contact" class="footer-link">{{ 'marketing.footer.contactSales' | translate }}</a></li>
          <li>{{ 'marketing.footer.emailLabel' | translate }}<a href="mailto:ima@ima-ems.com">ima&#64;ima-ems.com</a></li>
          <li>{{ 'marketing.footer.phoneLabel' | translate }}<a href="tel:02-66168178">02-66168178</a></li>
          <li>{{ 'marketing.footer.lineLabel' | translate }}<a href="https://page.line.me/ict8881e" target="_blank" rel="noopener">&#64;ict8881e</a></li>
          <li>{{ 'marketing.footer.hours' | translate }}</li>
        </ul>
      </div>

    </div>

    <hr class="footer-divider">

    <div class="footer-bottom">
      <p class="footer-bottom__copy">{{ 'marketing.footer.copyright' | translate }}</p>
      <div class="footer-bottom__links">
        <a routerLink="/legal/terms" class="footer-link">{{ 'marketing.footer.terms' | translate }}</a>
        <a routerLink="/legal/privacy" class="footer-link">{{ 'marketing.footer.privacyPolicy' | translate }}</a>
        <a routerLink="/help" class="footer-link">{{ 'marketing.footer.userGuide' | translate }}</a>
        <a routerLink="/contact-us" class="footer-link">{{ 'marketing.footer.contactWindow' | translate }}</a>
      </div>
      <app-language-switcher placement="footer" />
    </div>
  </div>
</footer>
